import Header from "./Header"
import Footer from "./Footer"
import { Box } from "@mui/material"

const Layout = ({ children, categories, seo }) => (
  <div style={{ height: "100%", display: "flex", flexDirection: "column", overflow: "auto" }}>
    <Header />
    <Box flexGrow={1}>{children}</Box>
    <Footer />
  </div>
)

export default Layout
